import ApiClient from "Store/client";

export const assignLessonToStudentApi = (body) =>
  ApiClient(`api/commands/assign-lesson-to-student`, {
    method: "POST",
    body,
    type: "text"
  });

export const fetchStudentLessonListApi = (student, queryString = "") =>
  ApiClient<Lesson[]>(`api/students/${student}/student_lessons${queryString}`);

export const resetStudentLessonsApi = (body) =>
  ApiClient(`api/commands/reset-student-lessons`, {
    method: "PATCH",
    body
  });

export const unAssignLessonFromStudentApi = (body) =>
  ApiClient(`api/commands/unassign-lesson-from-student`, {
    method: "POST",
    body
  });

export const rescheduleStudentLessonsApi = (body) =>
  ApiClient(`api/commands/reschedule-student-lessons`, {
    method: "PATCH",
    body
  });

export const fetchStudentLessonApi = (student_id, lesson_id) =>
  ApiClient<Lesson>(`api/students/${student_id}/student_lessons/${lesson_id}`);

export const fetchStudentLessonSectionApi = (student_id, lesson_id, section_id) =>
  ApiClient<Section>(
    `api/students/${student_id}/student_lessons/${lesson_id}/sections/${section_id}`
  );

export const excuseStudentLessonLatenessApi = (body) =>
  ApiClient(`api/commands/excuse-student-lesson-lateness`, {
    method: "PATCH",
    body
  });

// @TODO: should be used in app, not used right now
export const rescoreStudentLessonApi = (body) =>
  ApiClient(`api/commands/rescore-student-lesson`, {
    method: "PATCH",
    body
  });

export const startStudentLessonSectionApi = (body) =>
  ApiClient(`api/commands/start-student-lesson-section`, {
    method: "PATCH",
    body
  });

export const addBulkAnswersToLessonApi = (body) =>
  ApiClient(`api/commands/bulk-student-lesson-answers`, {
    method: "POST",
    body
  });

export const fetchAllCalendarLessonsApi = (student_id) =>
  ApiClient(`api/students/${student_id}/student_lessons_calendar`);

export const markAllLessonFlagsReviewedApi = (body) =>
  ApiClient(`api/commands/mark-student-lesson-flags-reviewed`, {
    method: "POST",
    body
  });

export const updateStudentLessonProblemFlagApi = (body) =>
  ApiClient(`api/commands/flag-student-lesson-problem`, {
    method: "POST",
    body,
    type: "text"
  });

/* ====== UNUSED APIS ====== */

export const updateStudentLessonStatusApi = (body) =>
  ApiClient(`api/commands/update-student-lesson-status`, {
    method: "PATCH",
    body
  });

export const addStudentLessonProblemAnswerApi = (body) =>
  ApiClient(`api/commands/add-student-lesson-problem-answer`, {
    method: "POST",
    body
  });

/* This endpoint should be used only on student's app*/
// export const addLessonProblemVideoWatchedTime = (body) =>
//   ApiClient(`api/commands/watch-student-lesson-problem-video`, {
//     method: "POST",
//     body
//   });
